<template>
    <div class="text-block block-card card-border big-card-block">
        <v-expansion-panel expand :value="panel">
            <v-expansion-panel-content :lazy="true">
                <template v-slot:header >
                    <div class="block-card-title handle" >
                        <div class="title-icon">
                            <img src="../../../../assets/img/travel.png" alt="">
                        </div>

                        <h4>Travel</h4>
                    </div>
                </template>
                <div class="block-card-body">
                    <label >Passenger Title</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.passengerTitle"-->
<!--                            :error="!data.passengerTitle"-->
<!--                            :error-messages="!data.passengerTitle? 'Passenger Title is Required':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.passengerTitle" :type="'textfield'"
                                           :validationRules=" [v => !!v || 'Passenger Title is Required']">

                    </vTextareaAutocomplete>
                    <label >Passengers Text</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.passengersText"-->
<!--                            :error="!data.passengersText"-->
<!--                            :error-messages="!data.passengersText? 'Passengers Text is Required':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.passengersText" :type="'textfield'"
                                           :validationRules=" [v => !!v || 'Passenger Text is Required']">

                    </vTextareaAutocomplete>
                    <label >Passengers</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.passengers"-->
<!--                            :error="!data.passengers"-->
<!--                            :error-messages="!data.passengers? 'Passengers  is Required':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.passengers" :type="'textfield'"
                                           :validationRules=" [v => !!v || 'Passengers Text is Required']">

                    </vTextareaAutocomplete>
<!--                    stop1-->
                    <label class="mt-4">Stop Number</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.stopsNumber"-->
<!--                            :error="!data.stopsNumber"-->
<!--                            :error-messages="!data.stopsNumber? 'Stop Number  is Required':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.stopsNumber" :type="'textfield'"
                                           :validationRules=" [v => !!v || 'Stop Number  Text is Required']">

                    </vTextareaAutocomplete>
                    <v-layout row v-if="data.stops">
                        <v-flex sm4 class="pa-0">
                            <label class="mt-4">Stop Date</label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.stops.date"-->
<!--                                    :error="!data.stops.date"-->
<!--                                    :error-messages="!data.stops.date? 'Stop Date is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.stops.date" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Stop Date  Text is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                        <v-flex sm4></v-flex>
                        <v-flex sm4 class="pa-0">
                            <label class="mt-4">Stop Time</label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.stops.time"-->
<!--                                    :error="!data.stops.time"-->
<!--                                    :error-messages="!data.stops.time? 'Stop Time is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.stops.time" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Stop Time  Text is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout class="mt-4 align-center" v-if="data.stops">
                        <v-flex sm4 class="pa-0">
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.stops.originName"-->
<!--                                    :error="!data.stops.originName"-->
<!--                                    placeholder="Origin Name"-->

<!--                                    :error-messages="!data.stops.originName? 'Origin Name is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.stops.originName" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Origin Name Text is Required']">

                            </vTextareaAutocomplete>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.stops.originAcronym"-->
<!--                                    :error="!data.stops.originAcronym"-->
<!--                                    placeholder="Origin Acc"-->
<!--                                    :error-messages="!data.stops.originAcronym? 'Origin Acronym is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.stops.originAcronym" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Origin Acronym  Text is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>

                        <v-flex sm4 class="text-sm-center">
                            <v-icon color="primary" large>airplanemode_active</v-icon>
                        </v-flex>

                        <v-flex sm4 class="pa-0">
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.stops.destName"-->
<!--                                    :error="!data.stops.destName"-->
<!--                                    placeholder="Destination"-->
<!--                                    :error-messages="!data.stops.destName? 'Destination Name is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.stops.destName" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Destination Name  Text is Required']">

                            </vTextareaAutocomplete>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.stops.destAcronym"-->
<!--                                    :error="!data.stops.destAcronym"-->
<!--                                    placeholder="destAcronym"-->
<!--                                    :error-messages="!data.stops.destAcronym? 'Destination Acronym Name is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.stops.destAcronym" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Destination Acronym  Text is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>

                    </v-layout>
<!--                    stop2-->
                    <label class="mt-8">Stop Number</label>
<!--                    <v-text-field-->
<!--                            outline-->
<!--                            v-model="data.nonStopsText"-->
<!--                            :error="!data.nonStopsText"-->
<!--                            :error-messages="!data.nonStopsText? 'nonStopsText is Required':''"-->
<!--                    >-->
<!--                    </v-text-field>-->
                    <vTextareaAutocomplete v-model="data.nonStopsText" :type="'textfield'"
                                           :validationRules=" [v => !!v || 'Non StopsText Text is Required']">

                    </vTextareaAutocomplete>
                    <v-layout row v-if="data.nonStops">
                        <v-flex sm4 class="pa-0">
                            <label class="mt-4">Stop Date</label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.nonStops.date"-->
<!--                                    :error="!data.nonStops.date"-->
<!--                                    :error-messages="!data.nonStops.date? 'Stop Date is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.nonStops.date" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Non Stop Date is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                        <v-flex sm4></v-flex>
                        <v-flex sm4 class="pa-0">
                            <label class="mt-4">Stop Time</label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.nonStops.time"-->
<!--                                    :error="!data.nonStops.time"-->
<!--                                    :error-messages="!data.nonStops.time? 'Stop Time is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.nonStops.time" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Non Stop Time is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                    </v-layout>
                    <v-layout class="mt-4 align-center" v-if="data.nonStops">
                        <v-flex sm4 class="pa-0">
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.nonStops.originName"-->
<!--                                    :error="!data.nonStops.originName"-->
<!--                                    placeholder="Origin Name"-->

<!--                                    :error-messages="!data.nonStops.originName? 'Origin Name is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.nonStops.originName" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Non Stop origin Name is Required']">

                            </vTextareaAutocomplete>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.nonStops.originAcronym"-->
<!--                                    :error="!data.nonStops.originAcronym"-->
<!--                                    placeholder="Origin Acc"-->
<!--                                    :error-messages="!data.nonStops.originAcronym? 'Origin is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.nonStops.originAcronym" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Non Stop origin Acronym is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>

                        <v-flex sm4 class="text-sm-center">
                            <v-icon color="primary" large>airplanemode_active</v-icon>
                        </v-flex>

                        <v-flex sm4 class="pa-0">
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.nonStops.destName"-->
<!--                                    :error="!data.nonStops.destName"-->
<!--                                    placeholder="Destination"-->
<!--                                    :error-messages="!data.nonStops.destName? 'Destination Name is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.nonStops.destName" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Non Stop Destination is Required']">

                            </vTextareaAutocomplete>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.nonStops.destAcronym"-->
<!--                                    :error="!data.nonStops.destAcronym"-->
<!--                                    placeholder="destAcronym"-->
<!--                                    :error-messages="!data.nonStops.destAcronym? 'destAcronym Name is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.nonStops.destAcronym" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Non Stop Destination Acronym is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>

                    </v-layout>
<!--                    end nonstiop-->
                    <v-layout row v-if="data.stops">
                        <v-flex sm4 class="pa-0">
                            <label class="mt-4">Total Text</label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.totalText"-->
<!--                                    :error="!data.totalText"-->
<!--                                    :error-messages="!data.totalText? 'Total Text is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.totalText" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Total Text is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                        <v-flex sm4></v-flex>
                        <v-flex sm4 class="pa-0">
                            <label class="mt-4">Total</label>
<!--                            <v-text-field-->
<!--                                    outline-->
<!--                                    v-model="data.total"-->
<!--                                    :error="!data.total"-->
<!--                                    :error-messages="!data.total? 'Total is Required':''"-->
<!--                            >-->
<!--                            </v-text-field>-->
                            <vTextareaAutocomplete v-model="data.total" :type="'textfield'"
                                                   :validationRules=" [v => !!v || 'Total is Required']">

                            </vTextareaAutocomplete>
                        </v-flex>
                    </v-layout>
                </div>
            </v-expansion-panel-content>
        </v-expansion-panel>
    </div>
</template>

<script>
    import common from "../../../../utils/common"
    export default {
        name: "card-audio",
        props: {
            data: {
                type: Object,
                default: ()=> {
                    return {}
                }
            },
            index: {
                type: Number,
                default: ()=> {
                    return 0
                }
            },
            blocksList: {
                type: Array,
                default: ()=> {
                    return []
                }
            }
        },
        data() {
            return {
                valid: true,
                panel: 1,
                common
            }
        },
        mounted() {

        },
        methods: {

        },
        computed: {

        },
        watch: {

        }
    }
</script>

<style scoped>

</style>